import { platformClient } from '@/api/http/platformClient'
import type { ApiResponse } from '@/api/http/types'
import type { TeamMemberDto } from './teamMembers.types'
import type { ValidateTeamInvitationData } from './teamInvitation.types'

/** Public team invitation calls must not redirect to /login on 401 (unauthenticated). */
const publicRequestConfig = { skipUnauthorizedRedirect: true } as const

export async function validateTeamInvitationToken(
  token: string,
): Promise<ValidateTeamInvitationData> {
  const { data } = await platformClient.get<ApiResponse<ValidateTeamInvitationData>>(
    `/api/v1/team/invitation/validate/${encodeURIComponent(token)}`,
    publicRequestConfig,
  )
  return data.data
}

export async function completeTeamInvitation(body: {
  token: string
  password: string
}): Promise<TeamMemberDto> {
  const { data } = await platformClient.post<ApiResponse<TeamMemberDto>>(
    '/api/v1/team/invitation/complete',
    body,
    publicRequestConfig,
  )
  return data.data
}
